import React, { useState } from 'react';
import { motion } from 'framer-motion';
import AuthInput from './AuthInput';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { apiLogin } from '../../services/api';

const { FiMail, FiLock, FiArrowRight } = FiIcons;

const DEMO_EMAIL = 'demo';
const DEMO_PASSWORD = 'demo';

export default function LoginForm({ onAuth, onSignUp, onForgot }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const e = {};
    if (!email.trim()) e.email = 'Email is required';
    if (!password) e.password = 'Password is required';
    if (email === DEMO_EMAIL && password === DEMO_PASSWORD) return {};
    if (email !== DEMO_EMAIL && !/\S+@\S+\.\S+/.test(email)) e.email = 'Enter a valid email';
    if (password.length < 6) e.password = 'At least 6 characters';
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setErrors({});
    setLoading(true);
    try {
      const { user } = await apiLogin(email.trim().toLowerCase(), password);
      onAuth(user);
    } catch (err) {
      setErrors({ email: err.message || 'Login failed. Please check your credentials.' });
    } finally {
      setLoading(false);
    }
  };

  const handleDemo = () => {
    setErrors({});
    setLoading(true);
    setTimeout(() => { setLoading(false); onAuth({ email: 'demo', isDemo: true }); }, 800);
  };

  return (
    <div>
      <AuthInput
        label="Username or Email"
        type="text"
        value={email}
        onChange={setEmail}
        placeholder="you@example.com"
        icon={FiMail}
        error={errors.email}
      />
      <AuthInput
        label="Password"
        type="password"
        value={password}
        onChange={setPassword}
        placeholder="••••••••"
        icon={FiLock}
        error={errors.password}
      />

      <button
        onClick={onForgot}
        className="font-sans text-xs text-stone-400 mb-6 block ml-1 active:text-stone-600 transition-colors"
      >
        Forgot your password?
      </button>

      <motion.button
        whileTap={{ scale: 0.97 }}
        onClick={handleSubmit}
        disabled={loading}
        className="w-full py-4 rounded-full font-sans font-semibold text-white text-base flex items-center justify-center gap-2 shadow-md mb-4 disabled:opacity-70"
        style={{ background: 'linear-gradient(135deg, #C07A52, #E8C97A)' }}
      >
        {loading ? (
          <div className="w-5 h-5 border-2 border-white/40 border-t-white rounded-full animate-spin" />
        ) : (
          <><span>Sign In</span><SafeIcon icon={FiArrowRight} /></>
        )}
      </motion.button>

      <button
        onClick={handleDemo}
        disabled={loading}
        className="w-full py-3.5 rounded-full font-sans font-medium text-stone-500 text-sm bg-white/60 border border-stone-200 mb-6 active:bg-white transition-colors disabled:opacity-60"
      >
        Try demo account
      </button>

      <div className="flex items-center gap-3 mb-6">
        <div className="flex-1 h-px bg-stone-200" />
        <span className="font-sans text-xs text-stone-300">or</span>
        <div className="flex-1 h-px bg-stone-200" />
      </div>

      <p className="text-center font-sans text-sm text-stone-500">
        New here?{' '}
        <button onClick={onSignUp} className="font-semibold text-stone-800 active:text-stone-600 transition-colors">
          Create an account
        </button>
      </p>
    </div>
  );
}
